import 'core-js/stable';
import 'regenerator-runtime/runtime';

// 引入 Tailwind CSS（必须在其他样式之前引入）
import './styles/tailwind.css';

import * as React from "react";
import { createRoot } from "react-dom/client";

import App from './app';

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
